module.exports = __webpack_public_path__ + "Roboto-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Medium.woff2
// module id = 96
// module chunks = 0